import { deriveUID } from '@sqior/js/uid';

/** Method returning a string representing the PIN code in non-readable fashion */

export function encodePIN(user: string, pinCode: string) {
  return deriveUID(user, pinCode);
}
